<template>
    <section>
        <div class="card shadow-sm mb-4 border-0">
            <div class="card-header background-primary">
                <div class="row justify-content-end">
                    <div class="col">
                        &nbsp;
                    </div>
                    <div class="ml-auto col-auto" v-if="roleElligibleModified()">
                        <router-link v-bind:to="{ name: 'tryout/online/edit', params: {id: tryout.id} }" class="btn btn-link h4 p-0 my-0 mr-2">
                            Edit
                        </router-link>
                        <button class="btn btn-link h4 p-0 m-0" v-on:click="$emit('confirm', tryout)">
                            Delete
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="card-title text-muted mb-0">
                    Nama TO:
                </div>
                <router-link v-bind:to="{name: 'tryout/online/view', params: {id: tryout.id}}" class="mb-2 d-block text-loading">
                    <template v-if="tryout.name">{{ tryout.name }}</template>
                </router-link>
                <div class="card-title text-muted mb-0">
                    Kelas:
                </div>
                <p class="mb-2">
                    <ul class="mb-0 pl-3">
                        <li v-for="grade in tryout.grades" v-bind:key="grade.id" class="text-loading mb-1">{{ grade.name }}</li>
                    </ul>
                </p>
                <template v-if="tryout.tryoutGroups.length">
                    <template v-for="tryoutGroup in tryout.tryoutGroups">
                        <div class="card-title text-muted mb- text-loading">
                            <template v-if="tryoutGroup.groupSubject">{{ tryoutGroup.groupSubject.name }}:</template>
                        </div>
                        <p class="mb-2">
                            <ul class="mb-0 pl-3">
                                <li v-for="tryoutSubject in tryoutGroup.tryoutSubjects" v-bind:key="tryoutSubject.id" class="text-loading mb-1">
                                    <template v-if="tryoutSubject.subject">{{ tryoutSubject.subject.name }}</template>
                                </li>
                            </ul>
                        </p>
                    </template>
                </template>
                <template v-else>
                    <div class="card-title text-muted mb-0">
                        Mata Pelajaran:
                    </div>
                    <p class="mb-2">
                        <ul class="mb-0 pl-3">
                            <li v-for="tryoutSubject in tryout.tryoutSubjects" v-bind:key="tryoutSubject.id" class="text-loading mb-1">
                                <template v-if="tryoutSubject.subject">{{ tryoutSubject.subject.name }}</template>
                            </li>
                        </ul>
                    </p>
                </template>
                <template v-if="tryout.tryoutOnline">
                    <div class="card-title text-muted mb-0">
                        Tanggal TO:
                    </div>
                    <p class="mb-2">
                        {{ [tryout.tryoutOnline.start, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH.mm") }} 
                        s/d 
                        {{ [tryout.tryoutOnline.end, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH.mm") }}
                    </p>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';

    /**
     * @param {Object} tryout
     * 
     * @event confirm({Object})
     */
    export default {
        name: "TryoutOnlineItem",
        props: ['tryout'],
        computed: mapState([
            'profile'
        ]),
        methods: {
            roleElligibleModified() {
                return this.profile.isAdmin;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/tryout/online/item/Tryout.vue